import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d57b52b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info_portrait" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info_list" }
const _hoisted_5 = { class: "info_list_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "昵称", -1))
const _hoisted_7 = { class: "info_list_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手机号", -1))
const _hoisted_9 = { class: "info_list_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所属部门", -1))
const _hoisted_11 = { class: "info_list_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "岗位", -1))
const _hoisted_13 = { class: "info_list_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前组织", -1))

import { useStore } from "vuex"

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore()

    let avatar: any = require('@/assets/icon/2@2x.png')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(store).state.userInfo.avatar ? _unref(store).state.userInfo.avatar : _unref(avatar),
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.companyUser.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.realname ? _unref(store).state.userInfo.realname : '暂无昵称'), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.companyUser.phone ? _unref(store).state.userInfo.companyUser.phone : '暂无手机号'), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.department.name ? _unref(store).state.userInfo.department.name : '暂无所属部门'), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.companyUser.positionName ? _unref(store).state.userInfo.companyUser.positionName : '暂无岗位'), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", null, _toDisplayString(_unref(store).state.userInfo.rootDepartment.name ? _unref(store).state.userInfo.rootDepartment.name : '暂无组织'), 1)
      ])
    ])
  ]))
}
}

})